import ReactDateRangePicker from "components/ReactDateRangePicker/ReactDateRangePicker";
import RoundTab from "components/RoundTabButtons/RoundTab";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import LeftArrow_3 from "../../../assets/img/icons/LeftArrow_3.svg";
import RightArrow_3 from "../../../assets/img/icons/RightArrow_3.svg";
import AddSingleMemberDropdown from "../../../components/CustomDropdown/AddSingleMemberDropdown";
import CreateProjectDropdown from "../../../components/DropdownStyle/CreateProjectDropdown";
import Select from "../../../components/ReactSelectDropdown";
import { filterOption } from "../../../components/ReactSelectDropdown/ReactSelectDropdown";
import SearchWithButton from "../../../components/Search/SearchWithButton";
import ClearFilterButton from "../../../components/Search/clearFilterButton";
import {
  FilterButton,
  TabButton,
  WhiteButton,
} from "../../../styledComponents/buttons";
import {
  CommonFlex,
  CommonFlexWrap,
  CommonGrid,
  FilterLabel,
  IconArrow,
  InputWithLabelSection,
} from "../../../styledComponents/common";
import { TaskFilterContainer } from "../../../styledComponents/taskApproval";
import {
  TabButtonContainer,
  TabSearchGrid,
} from "../../../styledComponents/taskApproval";

const TaskFilter = ({
  selectedOrganization,
  getOrganizationMembersList,
  organizationMembersList,
  getOfficesShortList,
  officesShortList,
  selectedOffice,
  selectOffice,
  getWorkOrderShortList,
  workOrderShortList,
  selectedWorkOrder,
  selectWorkOrder,
  selectedMember,
  selectMember,
  clearMember,
  handleSearchByName,
  handleClearSearch,
  searchTerm,
  onSearchTermChange,
  handleSelectedTab,
  selectedTab,
  selectToday,
  singleDateChange,
  startDate,
  endDate,
  onDateSelect,
  selectLastWeek,
  selectLastMonth,
  selectNextWeek,
  changeDateRange,
  dateLabel,
}) => {
  const { t } = useTranslation();

  // Dynamic labels based on organization type (default to "operation" if not defined)
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";

  const [officeOptions, setOfficeOptions] = useState([]);
  const [workOrderOptions, setWorkOrderOptions] = useState([]);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id && isOperationType) {
      getWorkOrderShortList({ organization_id: selectedOrganization.id });
    }
  }, [selectedOrganization, isOperationType]);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      // getWorkOrderShortList({ organization_id: selectedOrganization.id });
      getOrganizationMembersList({ organization_id: selectedOrganization.id });
    }
  }, [selectedOrganization]);

  // useEffect(() => {
  //   // getOfficesShortList();
  //   getOrganizationMembersList({ office_id: null });
  // }, []);

  // useEffect(() => {
  //   if (officesShortList && officesShortList.length === 1) {
  //     getOrganizationMembersList({ office_id: officesShortList[0].id });
  //   }
  //   if (officesShortList && officesShortList.length > 1) {
  //     let newArr = [
  //       {
  //         label: `(${t('all_offices')})`,
  //         value: null,
  //       },
  //     ];
  //     officesShortList.forEach((office, i) => {
  //       newArr.push({
  //         label: office.name,
  //         value: office.id,
  //       });
  //     });
  //     setOfficeOptions(newArr);
  //   }
  // }, [officesShortList]);

  useEffect(() => {
    if (workOrderShortList && workOrderShortList.length > 0) {
      let newArr = [
        {
          label: `(${t(isOperationType ? "all_tasks" : "all_jobs")})`,
          value: null,
        },
      ];
      workOrderShortList.forEach((workorder, i) => {
        newArr.push({
          label: workorder.name,
          value: workorder.id,
        });
      });
      setWorkOrderOptions(newArr);
    }
  }, [workOrderShortList, orgType, t]);

  // useEffect(() => {
  //   if (
  //     selectedOffice &&
  //     selectedOffice.value &&
  //     officesShortList &&
  //     officesShortList.length > 1
  //   ) {
  //     getOrganizationMembersList({ office_id: selectedOffice.value });
  //   }
  // }, [selectedOffice]);

  const onMemberSelect = person => {
    selectMember(person);
  };

  const gridColumns = isOperationType
    ? "max-content minmax(170px, 195px) 40px minmax(180px, 200px) minmax(344px, 354px)"
    : "max-content 40px minmax(180px, 200px) minmax(344px, 354px)";

  return (
    <CommonFlexWrap columns={gridColumns}>
      <TabSearchGrid>
        <InputWithLabelSection>
          <FilterLabel>{t("type")}</FilterLabel>
          <CommonGrid
            columns="max-content max-content max-content"
            gap="5px"
            disableResponsive
          >
            <RoundTab
              text={t("submitted")}
              selected={selectedTab === "submitted"}
              onClick={() => handleSelectedTab("submitted")}
              showIcon={false}
              tooltipEnabled={true}
              tooltipText={t(isOperationType ? "choose_submitted_tasks_data" : "choose_submitted_jobs_data")}
            />
            <RoundTab
              text={t("approved")}
              selected={selectedTab === "approved"}
              onClick={() => handleSelectedTab("approved")}
              showIcon={false}
              tooltipEnabled={true}
              tooltipText={t(isOperationType ? "choose_approved_tasks_data" : "choose_approved_jobs_data")}
            />
            <RoundTab
              text={t("rejected")}
              selected={selectedTab === "rejected"}
              onClick={() => handleSelectedTab("rejected")}
              showIcon={false}
              tooltipEnabled={true}
              tooltipText={t(isOperationType ? "choose_rejected_tasks_data" : "choose_rejected_jobs_data")}
            />
          </CommonGrid>
        </InputWithLabelSection>
      </TabSearchGrid>
      {isOperationType && (
        <InputWithLabelSection>
          <FilterLabel>{t("project")}</FilterLabel>
          <Select
            isSearchable
            isClearable={selectedWorkOrder?.value}
            value={selectedWorkOrder}
            options={workOrderOptions}
            placeholder="Select WorkOrder"
            onChange={e => {
              e
                ? selectWorkOrder(e)
                : selectWorkOrder({
                    label: `(${t("all_projects")})`,
                    value: null,
                  });
            }}
            styles={CreateProjectDropdown()}
            filterOption={filterOption}
            components={{
              IndicatorSeparator: () => null,
              ClearIndicator: props => {
                return <ClearFilterButton {...props} />;
              },
            }}
          />
        </InputWithLabelSection>
      )}
      <InputWithLabelSection>
        <FilterLabel>{t("for")}</FilterLabel>
        <AddSingleMemberDropdown
          assigneeManage={selectedMember}
          updateState={onMemberSelect}
          membersList={organizationMembersList}
          clearAssignee={() => clearMember()}
          page="job_approval"
          closeDisabled={true}
        />
      </InputWithLabelSection>
      <SearchWithButton
        searchTermName={t(isOperationType ? "task_name" : "job_name")}
        searchInput={searchTerm}
        onInputChange={onSearchTermChange}
        handleSearch={handleSearchByName}
        handleClearSearch={handleClearSearch}
      />

      <CommonFlex responsiveBreakpoint="512px" gap="4px" alignItems="end">
        <InputWithLabelSection>
          <FilterLabel>
            {t("date_range")}
            {` (${dateLabel})`}
          </FilterLabel>
          <ReactDateRangePicker
            startDate={startDate ? moment(startDate) : null}
            startDateId="report-date-range-start-date"
            endDate={endDate ? moment(endDate) : null}
            endDateId="report-date-range-end-date"
            onDatesChange={changeDateRange}
            onDateSelect={onDateSelect}
            selectLastWeek={selectLastWeek}
            selectLastMonth={selectLastMonth}
            selectNextWeek={selectNextWeek}
            rangeRestricted={true}
            disableFutureDates={false}
          />
        </InputWithLabelSection>
        <IconArrow
          onClick={() => {
            singleDateChange("left");
          }}
          padding="5px"
          size="39px"
          src={LeftArrow_3}
        />
        <IconArrow
          onClick={() => {
            moment(endDate).isBefore(moment().subtract(1, "day")) &&
              singleDateChange("right");
          }}
          disabled={!moment(endDate).isBefore(moment().subtract(1, "day"))}
          padding="5px"
          size="39px"
          src={RightArrow_3}
        />
        <WhiteButton
          type="nav"
          style={{
            height: "38px",
            padding: "0px 15px",
          }}
          onClick={selectToday}
          borderRadius="6px"
        >
          Today
        </WhiteButton>
      </CommonFlex>
    </CommonFlexWrap>
  );
};

export default TaskFilter;
